import React, { useState } from "react";
import { message } from "antd";
import { uploadAlbumImages } from "../../services/galleryService"; // ✅ Make sure this service exists

const ImageUploadModal = ({ isVisible, onClose, album, onUpload }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploading, setUploading] = useState(false);

  if (!isVisible || !album) return null;

  const handleFileChange = (e) => {
    setSelectedFiles(Array.from(e.target.files));
  };

  const handleUpload = async () => {
    if (selectedFiles.length === 0) return;
    setUploading(true);

    try {
      const formData = new FormData();
      formData.append("album_id", album.album_id); // <-- make sure this matches your DB column

      selectedFiles.forEach((file) => {
        formData.append("images", file);
      });

      const res = await uploadAlbumImages(formData);
      message.success(`${res.images.length} image(s) uploaded successfully.`);
      onUpload(album.album_id, res.images); // inform parent
      setSelectedFiles([]);
      onClose();
    } catch (error) {
      console.error("Upload failed:", error);
      message.error("Failed to upload images.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Upload Images to {album.title}</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Select Images</label>
                <input
                  type="file"
                  className="form-control"
                  multiple
                  accept="image/*"
                  onChange={handleFileChange}
                  disabled={uploading}
                />
              </div>

              {selectedFiles.length > 0 && (
                <div className="mb-3">
                  <h6>Selected Files ({selectedFiles.length}):</h6>
                  <div className="row g-2">
                    {selectedFiles.map((file, i) => (
                      <div className="col-6 col-md-4" key={i}>
                        <div className="card">
                          <div className="card-body p-2 d-flex align-items-center">
                            <img
                              src={URL.createObjectURL(file)}
                              alt="preview"
                              className="img-thumbnail me-2"
                              style={{ width: 50, height: 50, objectFit: "cover" }}
                            />
                            <div>
                              <small className="d-block">{file.name}</small>
                              <small className="text-muted">{(file.size / 1024).toFixed(1)} KB</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="text-end">
                <button className="btn btn-secondary me-2" onClick={onClose} disabled={uploading}>
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleUpload}
                  disabled={uploading || selectedFiles.length === 0}
                >
                  {uploading ? "Uploading..." : "Upload Images"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ImageUploadModal;
